import { Link } from 'react-router-dom';
import Navbar from '../components/feature/Navbar';
import Footer from '../components/feature/Footer';

export default function NotFound() {
  return (
    <div>
      <Navbar />
      <main className="min-h-screen flex items-center justify-center px-6 bg-white">
        <div className="text-center">
          <p className="font-heading text-8xl text-neutral-100 font-light mb-4">404</p>
          <h1 className="font-heading text-3xl text-neutral-900 font-light mb-4">Page introuvable</h1>
          <p className="text-sm text-neutral-500 mb-8 max-w-sm mx-auto">
            La page que vous recherchez n'existe pas ou a été déplacée.
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-3.5 bg-neutral-900 text-white text-sm font-medium rounded-sm hover:bg-neutral-800 transition-colors cursor-pointer whitespace-nowrap"
          >
            Retour à l'accueil
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
